export const API_TMDB_URL = "5bb50da6b298a05c537ee2a62a4bf55d";
export const BASE_URL = "https://api.themoviedb.org/3";
export const IMG_URL = "https://image.tmdb.org/t/p/original";
export const IMG_URL_500 = "https://image.tmdb.org/t/p/w500";
